// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-navigator-settings {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 40px;
  max-width: 399px;
  flex: 1;
}
.sub-navigator-settings > * {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.sub-navigator-settings__period-label {
  width: 130px;
}
.sub-navigator-settings__period-input.g-text-input {
  width: 80px;
}
.sub-navigator-settings__period-selector {
  width: 160px;
}
.sub-navigator-settings__navigator-line-selector {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/Settings/SettingNavigator/NavigatorSubSettings/NavigatorSubSettings.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,OAAA;AACJ;AAAI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAER;AACI;EACI,YAAA;AACR;AAEI;EACI,WAAA;AAAR;AAGI;EACI,YAAA;AADR;AAII;EACI,WAAA;AAFR","sourcesContent":[".sub-navigator-settings {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-left: 40px;\n  max-width: 399px;\n  flex: 1;\n}\n.sub-navigator-settings > * {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.sub-navigator-settings__period-label {\n  width: 130px;\n}\n.sub-navigator-settings__period-input.g-text-input {\n  width: 80px;\n}\n.sub-navigator-settings__period-selector {\n  width: 160px;\n}\n.sub-navigator-settings__navigator-line-selector {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
